import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, ButtonBase, Chip, Stack, Typography } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserSecret } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import { COUNTRIES } from "@/lib/countries";
export var ForensicPseudonym = function (_a) {
    var code = _a.code;
    return (_jsx(Chip, { icon: _jsx(FontAwesomeIcon, { icon: faUserSecret }), label: code, size: "small", variant: "outlined", sx: {
            "height": 24,
            "borderRadius": "4px",
            "bgcolor": "#F7F9FC",
            "borderColor": "#DFE6EF",
            "color": "#405269",
            "& .MuiChip-label": {
                fontFamily: '"DejaVu Sans Mono", ui-monospace, monospace',
                fontSize: 12,
                fontWeight: 600,
                letterSpacing: 0.5,
            },
            "& .MuiChip-icon": { color: "#64748B", fontSize: 11, ml: 1 },
        } }));
};
export var ForensicCountry = function (_a) {
    var _b;
    var code = _a.code, showName = _a.showName;
    return (_jsxs(Stack, { component: "span", direction: "row", alignItems: "center", spacing: 1, children: [_jsx(Box, { component: "span", sx: {
                    fontSize: 11,
                    fontWeight: 600,
                    color: "#475569",
                    border: "1px solid #CBD5E1",
                    borderRadius: "4px",
                    px: 0.75,
                    py: 0.15,
                    lineHeight: 1.5,
                }, children: code !== null && code !== void 0 ? code : "—" }), showName && code ? (_jsx(Typography, { component: "span", variant: "body2", color: "text.secondary", children: (_b = COUNTRIES.find(function (country) { return country.code === code; })) === null || _b === void 0 ? void 0 : _b.name })) : null] }));
};
export var ForensicBallotCount = function (_a) {
    var count = _a.count, shared = _a.shared;
    var t = useTranslation().t;
    return (_jsxs(Stack, { component: "span", direction: "row", alignItems: "center", justifyContent: "flex-end", spacing: 1, sx: { whiteSpace: "nowrap" }, children: [shared ? (_jsx(Chip, { label: t("ballotPrivacy.forensic.shared"), title: t("ballotPrivacy.forensic.sharedHelp"), size: "small", sx: {
                    height: 22,
                    borderRadius: "100px",
                    fontSize: 12,
                    fontWeight: 500,
                    bgcolor: "#FFF7D9",
                    color: "#6B5B26",
                    border: "1px solid #F1E3A6",
                } })) : null, _jsx(Box, { component: "span", sx: { fontWeight: 600, fontVariantNumeric: "tabular-nums" }, children: count })] }));
};
export var ForensicAddressButton = function (_a) {
    var ip = _a.ip, onOpen = _a.onOpen;
    return (_jsx(ButtonBase, { onClick: onOpen, sx: {
            "fontFamily": '"DejaVu Sans Mono", ui-monospace, monospace',
            "fontSize": 14,
            "color": "text.primary",
            "textAlign": "start",
            "overflowWrap": "anywhere",
            "justifyContent": "flex-start",
            "minWidth": 0,
            "borderRadius": "2px",
            "&:hover": { textDecoration: "underline" },
            "&.Mui-focusVisible": {
                outline: "2px solid",
                outlineColor: "primary.main",
                outlineOffset: 3,
            },
        }, children: ip }));
};
